import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import {Typography} from "@mui/material";
import Grid from "@mui/material/Grid";

const Contact = () => {
    return <Grid container direction="column" alignItems="center" justify="center" style={{ minHeight: '100vh' }}>
        <Grid>
            <Card>
                <CardContent>
                    <Typography variant={"h4"}>
                        Contact Us
                    </Typography>
                    <Typography sx={{ mb: 1.5 }} color="text.secondary">
                        Please email any suggestions/feedback to 
                    </Typography>
                    <a href="mailto:javier@javierpalomares.net">javier@javierpalomares.net</a>
                </CardContent>
            </Card>
        </Grid>
    </Grid>
}

export default Contact;